<div>
    <label><b>Total a Pagar</b></label>
    <div class="uk-text-large">{{ totalPayment | roMoney }}</div>
</div>

<div class="mt-1">
    <p>
        Para poder seguir con el proceso pago debe aceptar nuestros términos y condiciones,
        <b>recuerde leerlos con detenimiento antes.</b>
    </p>
</div>

<div class="tw-mt-2 tw-mb-8">
    <div class="club-checkbox">
        <input type="checkbox" id="tac" [(ngModel)]="accept" name="accept" />
        <label class="tw-w-full no-select" for="tac" c="">
            <b style="font-size: 15px"
                >Acepto los
                <a href="http://www.clubinter.org.pe/tyc/content/pagos-en-linea" target="_blank"
                    >términos y condiciones</a
                >
                del proceso de pago que establece el Club Internacional Arequipa.</b
            >
        </label>
    </div>
</div>

<div class="tw-flex tw-justify-between">
    <div>
        <button nz-button nzType="primary" (click)="onBack.emit()">
            <i class="uk-icon uk-icon-arrow-left"></i>&nbsp;&nbsp; Regresar
        </button>
    </div>

    <button nz-button nzType="primary" [disabled]="!accept" (click)="onReady.emit()">
        Siguiente Paso&nbsp;&nbsp;
        <i class="uk-icon uk-icon-arrow-right"></i>
    </button>
</div>
